import { IRecommendationTrackSource } from '@epicuro-next/models/recommendation-panels';
import { createAction, props } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

export const recommendationItemsShown = createAction(
  '[Recommendation] Items shown',
  props<
    IRecommendationTrackSource & {
      products: (Product & { index?: number })[];
    }
  >(),
);

export const recommendationItemClicked = createAction(
  '[Recommendation] Item clicked',
  props<
    IRecommendationTrackSource & {
      product?: Product;
    }
  >(),
);
